// src/components/ChangeEmail.js
import React, { useState } from 'react';
import { EmailAuthProvider, reauthenticateWithCredential, verifyBeforeUpdateEmail } from 'firebase/auth';
import { auth } from '../firebase';
import PasswordInput from './PasswordInput';
import './ChangePassword.css';

const ChangeEmail = () => {
  const [form, setForm] = useState({ password: '', newEmail: '' });
  const [saving,  setSaving]  = useState(false);
  const [success, setSuccess] = useState(false);
  const [error,   setError]   = useState('');

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);

    const user = auth.currentUser;
    if (!user || !user.email) {
      setError('No authenticated user found. Please log in again.');
      return;
    }

    setSaving(true);
    try {
      const credential = EmailAuthProvider.credential(user.email, form.password);
      await reauthenticateWithCredential(user, credential);
      await verifyBeforeUpdateEmail(user, form.newEmail);
      setSuccess(true);
      setForm({ password: '', newEmail: '' });
    } catch (err) {
      console.error('[ChangeEmail] Error:', err.code, err.message);
      if (err.code === 'auth/wrong-password' || err.code === 'auth/invalid-credential') {
        setError('Current password is incorrect.');
      } else if (err.code === 'auth/invalid-email') {
        setError('Please enter a valid email address.');
      } else if (err.code === 'auth/email-already-in-use') {
        setError('That email address is already in use by another account.');
      } else if (err.code === 'auth/requires-recent-login') {
        setError('Session expired. Please log out and log back in, then try again.');
      } else {
        setError(`Something went wrong: ${err.message}`);
      }
    }
    setSaving(false);
  };

  return (
    <div className="cp-section">
      <div className="cp-section-label">Change Email</div>
      {success ? (
        <div className="cp-success">
          ✓ A verification link has been sent to your new email. Your email will update once you click the link.
        </div>
      ) : (
        <form className="cp-form" onSubmit={handleSubmit}>
          <div className="cp-form-group">
            <label className="cp-label">Current Password</label>
            <PasswordInput
              className="cp-input"
              name="password"
              placeholder="Confirm your current password"
              value={form.password}
              onChange={handleChange}
              autoComplete="current-password"
            />
          </div>
          <div className="cp-form-group">
            <label className="cp-label">New Email Address</label>
            <input
              className="cp-input"
              type="email"
              name="newEmail"
              placeholder="new@example.com"
              value={form.newEmail}
              onChange={handleChange}
              autoComplete="email"
            />
          </div>

          {error && <div className="cp-error">{error}</div>}

          <button
            type="submit"
            className="btn btn-outline btn-sm cp-submit"
            disabled={saving || !form.password || !form.newEmail}
          >
            {saving ? 'SENDING...' : 'SEND VERIFICATION EMAIL'}
          </button>
        </form>
      )}
    </div>
  );
};

export default ChangeEmail;
